export default __webpack_public_path__ + "static/media/mtlsicon.16dc7d34.png";